import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";

export const Signup = ({ onSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const submitData = (data) => {
    // e.preventDefault();
    onSubmit(data);
    reset({
      name: "",
      email: "",
      password: "",
      role: "user",
    });
  };

  return (
    <form className="flex flex-col gap-4" noValidate onSubmit={handleSubmit(submitData)}>
      <Controller
        name="name"
        control={control}
        rules={{
          required: "Email is required",
        }}
        defaultValue={""}
        render={({ field }) => {
          return (
            <TextField
              required
              value={field.value}
              onChange={field.onChange}
              id="filled-required"
              label="Name"
              variant="filled"
              fullWidth
              error={errors.name}
              helperText={errors.name ? errors.name.message : ""}
              // sx={{
              //   "& .MuiFilledInput-root": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-input": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-underline:before": {
              //     borderBottomColor: "white",
              //   },
              //   "& .MuiInputLabel-root": {
              //     color: "#cecece",
              //   },
              //   "& .MuiInputLabel-root.Mui-focused": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-underline.MuiFilledInput-underline:hover:before": {
              //     borderBottomColor: "white",
              //   },
              //   "& .MuiFilledInput-underline:after": {
              //     borderBottomColor: "white",
              //   },
              // }}
            />
          );
        }}
      />
      <Controller
        name="email"
        rules={{
          required: "Email is required",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Invalid email address",
          },
        }}
        defaultValue={""}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              required
              value={field.value}
              onChange={field.onChange}
              id="filled-required"
              label="Email"
              variant="filled"
              fullWidth
              // defaultValue={""}
              error={errors.email}
              helperText={errors.email ? errors.email.message : ""}
              // sx={{
              //   "& .MuiFilledInput-root": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-input": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-underline:before": {
              //     borderBottomColor: "white",
              //   },
              //   "& .MuiInputLabel-root": {
              //     color: "#cecece",
              //   },
              //   "& .MuiInputLabel-root.Mui-focused": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-underline.MuiFilledInput-underline:hover:before": {
              //     borderBottomColor: "white",
              //   },
              //   "& .MuiFilledInput-underline:after": {
              //     borderBottomColor: "white",
              //   },
              // }}
            />
          );
        }}
      />
      <Controller
        name="password"
        rules={{
          required: "Password is required",
          minLength: {
            value: 8,
            message: "Password must be at least 8 characters",
          },
          pattern: {
            value: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])",
            message:
              "Password must contain one uppercase, one lowercase, one number and one special character",
          },
        }}
        defaultValue={""}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              required
              value={field.value}
              onChange={field.onChange}
              id="filled-password-input"
              label="Password"
              type={showPassword ? "text" : "password"}
              error={errors.password}
              helperText={errors.password ? errors.password.message : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      className="text-white"
                      sx={{
                        color: "black",
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
                inputProps: {
                  style: {
                    // color: "white",
                    fontWeight: "900",
                  },
                },
              }}
              // autoComplete="current-password"
              variant="filled"
              fullWidth
              // sx={{

              //   "& .MuiFilledInput-root": {
              //     color: "#cecece",
              //   },
              //   "& .MuiFilledInput-input": {
              //     color: "#cecece",
              //   },
              //   "& .MuiFilledInput-underline:before": {
              //     borderBottomColor: "#cecece",
              //   },
              //   "& .MuiInputLabel-root": {
              //     color: "#cecece",
              //   },
              //   "& .MuiInputLabel-root.Mui-focused": {
              //     color: "white",
              //   },
              //   "& .MuiFilledInput-underline.MuiFilledInput-underline:hover:before": {
              //     borderBottomColor: "#cecece",
              //   },
              //   "& .MuiFilledInput-underline:after": {
              //     borderBottomColor: "white",
              //   },
              // }}
            />
          );
        }}
      />
      <Button
        type="submit"
        className="w-[30%] self-center my-4"
        variant="contained"
        size="large"
        sx={{
          backgroundColor: "#e8442d",
          color: "white",
          fontWeight: "900",
          fontFamily: "Bai Jamjuree",
          "&:hover": {
            backgroundColor: "#e85d01",
          },
          "&:active": {
            backgroundColor: "#e85d01",
          },
        }}
      >
        Signup
      </Button>
    </form>
  );
};
